module.exports = __webpack_public_path__ + "img/login-backdrop-old.fbe10356.png";